import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import clsx from 'clsx';
import React from 'react';
import { seededWidth } from '../../seededWidth';
import { RowProps } from './types';
const BASE_WIDTH: Record<NonNullable<RowProps['size']>, number> = {
  sm: 20,
  md: 60,
  lg: 120
};
const RowSkeleton = t0 => {
  const $ = _c(10);
  const {
    className,
    size: t1,
    seed: t2
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const seed = t2 === undefined ? 0 : t2;
  const t3 = BASE_WIDTH[size];
  let t4;
  if ($[0] !== seed || $[1] !== t3) {
    t4 = seededWidth(seed, t3);
    $[0] = seed;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const width = t4;
  let t5;
  if ($[3] !== className) {
    t5 = clsx("flex flex-row items-center", className);
    $[3] = className;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== width) {
    t6 = <div className="h-5 rounded-xs bg-gray-300" style={{
      width
    }} />;
    $[5] = width;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = <div className={t5} data-sentry-component="RowSkeleton" data-sentry-source-file="index.tsx">{t6}</div>;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
};
export default RowSkeleton;